import { orderStatus } from 'utils/orderStatus';

export default {
    [orderStatus[0]?.name]: [
        {
            name: 'Requested',
            status: 'done',
        },
        {
            name: 'Manager Approval',
            status: 'hourglass',
        },
        {
            name: 'Provisioning',
            status: 'wait',
        },
        {
            name: orderStatus[4]?.name,
            status: 'wait',
        },
    ],
    [orderStatus[1]?.name]: [
        {
            name: 'Requested',
            status: 'done',
        },
        {
            name: 'Manager Approval',
            status: 'done',
        },
        {
            name: 'Provisioning',
            status: 'hourglass',
        },
        {
            name: orderStatus[4]?.name,
            status: 'wait',
        },
    ],
    [orderStatus[2]?.name]: [
        {
            name: 'Requested',
            status: 'done',
        },
        {
            name: 'Cancelled',
            status: 'clear',
        },
    ],
    [orderStatus[3]?.name]: [
        {
            name: 'Requested',
            status: 'done',
        },
        {
            name: 'Manager Approval',
            status: 'clear',
        },
        {
            name: 'Provisioning',
            status: 'wait',
        },
    ],
    [orderStatus[4]?.name]: [
        {
            name: 'Requested',
            status: 'done',
        },
        {
            name: 'Manager Approval',
            status: 'done',
        },
        {
            name: 'Provisioning',
            status: 'done',
        },
        {
            name: 'Completed',
            status: 'done',
        },
    ],
    [orderStatus[5]?.name]: [
        {
            name: 'Requested',
            status: 'done',
        },
        {
            name: 'Action Required',
            status: 'priority-high',
        },
        {
            name: 'Manager Approval',
            status: 'wait',
        },
        {
            name: 'Provisioning',
            status: 'wait',
        },
        {
            name: 'Completed',
            status: 'wait',
        },
    ],

    [orderStatus[6]?.name]: [
        {
            name: 'Requested',
            status: 'done',
        },
        {
            name: 'Manager Approval',
            status: 'done',
        },
        {
            name: 'Provisioning',
            status: 'done',
        },
        {
            name: orderStatus[4]?.name,
            status: 'hourglass',
        },
    ],
};
